var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',{staticStyle:{"height":"70vh","overflow":"auto"},domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('v-divider'),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v(" "+_vm._s(_vm.$t('ok'))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }